import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

// import { LightsProgrammingContext, LightsService } from '../services/lights.service';
import { LightsService, LightsProgrammingContext } from '../services/lights.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';
import { ProgrammingUtilsService as Utils } from '../../../common/services/utils.service';
import { CommonProgrammingContext } from '../../../common/services/shared-programming.service';

import { Command } from '../../../common/params/interfaces/command.interface';
import { Event } from './../../../common/interfaces/event.interface';
import { Parameter } from '../../../common/params/interfaces/parameter.interface';
import { DeviceEvent } from '../../../common/interfaces/event.interface';
import { Device } from '../../../common/interfaces/item.interface';
import { Light } from '../services/interfaces/light.interface';

@Component({
  selector: 'prg-select-parameters',
  templateUrl: './select-parameters.component.html',
  styleUrls: ['./select-parameters.component.less']
})
export class SelectParametersComponent extends BaseRoutingComponent {

  private _command: Observable<Command>;
  private _device: Observable<Light>;
  private _params: Observable<Parameter[]>;
  private _routeParams: Observable<{ command: string, id: string, lightId: string }>;

  private _snapshot = Utils.snapshot;

  constructor(
    public router: Router,
    protected store: Store<{
      lightsProgramming: LightsProgrammingContext,
      sharedProgramming: CommonProgrammingContext
    }>,
    private _route: ActivatedRoute,
    private _lights: LightsService,
    private _utils: Utils
  ) {
    super();
    this._routeParams = <Observable<{ command: string, id: string, lightId: string }>>this._route.params;

    this._routeParams.map(p => parseInt(p.lightId)).subscribe(id => this._lights.setActionLight(id));

    this._device = this.store.select(s => s.lightsProgramming.action.light);
    this._command = Observable.combineLatest(
      this._routeParams,
      this.store.select(s => s.lightsProgramming.action).filter(l => !!l && !!l.commands),
      (routeParams, action) => {
        let id = parseInt(routeParams.id) || undefined;
        return action.commands.find(c => c.command === routeParams.command && c.id === id);
      }
    );

    this._params = this._command.map(c => c.params);
  }

  private setCommand = () => {
    let command = Utils.snapshot<Command>(this._command);
    let params = Utils.snapshot<Parameter[]>(this._params);
    this._lights.setActionCommand(command, params);
  }


  private identify = (param: Parameter) => param.name + param.type;
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-lights/select-parameters/select-parameters.component.ts